export { default as IndexTableCheckbox } from './IndexTableCheckbox';
